export enum ItemResponsibleEnum {

    ARANGANATHANM = 'ARANGANATHAN  M',
    ARUNVEERAPPAN = 'ARUN  VEERAPPAN',
    ASHOKMANOJ = 'ASHOK  MANO J',
    BARUNKUMAR = 'B  ARUNKUMAR',
    BALAJIPANDURANGAN = 'BALAJI  PANDURANGAN',
    CHANDRALEKHADINESH = 'CHANDRALEKHA  DINESH',
    CHANDRASHEKHARGSHASTRI = 'CHANDRASHEKHAR G SHASTRI',
    CHITHRADURAI = 'CHITHRA  DURAI',
    ELAMURUGU = 'ELAMURUGU  ',
    GGANESAN = 'G  GANESAN',
    GJEBAGNANASINGH = 'G JEBA GNANA SINGH',
    GOPALAKRISHNANGUNASEKARAN = 'GOPALAKRISHNAN  GUNASEKARAN',
    IPRAKASH = 'I  PRAKASH',
    JAGANRAMALINGAM = 'JAGAN  RAMALINGAM',
    JANARDHANAM = 'JANARDHANA  M',
    KSNEMIDHARAN = 'K S  NEMIDHARAN',
    KARTHIKRAJENDRAN = 'KARTHIK  RAJENDRAN',
    KULANDAIVELP = 'KULANDAIVEL  P',
    MMADHAVAN = 'M  MADHAVAN',
    MAHENDRAN  ='MAHENDRAN  ',
    MANIGANDAN  ='MANIGANDAN  ',
    MANISHPUROHIT = 'MANISH  PUROHIT',
    MANOJKUMARC= 'MANOJ KUMAR C',
    MURALID='MURALI  D',
    MURALISV = 'MURALI  S V',
    MUTHUKUMARV='MUTHUKUMAR  V',
    NAGENDIRANAYYANDURAI = 'NAGENDIRAN  AYYANDURAI',
    NISCHITARSHETTY = 'NISCHITA R SHETTY',
    PRARTHANABHARGAVA = 'PRARTHANA  BHARGAVA',
    RAKESHSHARMA= 'RAKESH  SHARMA',
    RANJITKUMARGAUTAM = 'RANJIT KUMAR GAUTAM',
    RAVINDRANATHTAGORETIRUMALASETTY = 'RAVINDRANATH TAGORE TIRUMALASETTY',
    SANGEETARAZDAN = 'SANGEETA  RAZDAN',
    SEEMASINGH ='SEEMA  SINGH',
    SHANMUGAMKULANDAIVEL = 'SHANMUGAM  KULANDAIVEL',
    SHIVAKUMARGH = 'SHIVAKUMAR  G H',
    SIVAKUMARK = 'SIVAKUMAR  K',
    SURESHKUMAR   = 'SURESHKUMAR  ',
    TJEEVAN = 'T  JEEVAN',
    TMAHENDRAN = 'T  MAHENDRAN',
    VADIVELMURUGANA = 'VADIVEL  MURUGAN A',
    VINESHKRISHNANPP ='VINESH  KRISHNAN P P',
}
